import React, {useEffect, useState} from 'react';
import {ActivityIndicator, Dimensions, Image, Pressable, Text, TextInput, TouchableOpacity, View} from 'react-native';
import HomeCss from "./HomeCss";
import {Formik} from "formik";
import i18n from "../../services/i18n";
import {checkLookupOptions, doLookup, validateLookup} from "./HomeFunctions";
import {navigationService} from "../../services/NavigationService";
import hounslowLogo from '../../assets/images/hounslow/logoMain.png';
import knowsleyLogo from '../../assets/images/knowsley/logoMain.png';
import lambethLogo from '../../assets/images/lambeth/logoMain.png';
import oldhamLogo from '../../assets/images/oldham/logoMain.png';
import defaultLogo from '../../assets/images/ccp/logoMain.png';


const KnowsleyHomeView = ({navigation}: any) => {

    let isLowDimension = Dimensions.get('window').width < 500;
    const styles = HomeCss(isLowDimension);
    const i18title = i18n.t("items.title");
    const i18pcn = i18n.t("items.pcn");
    const i18vrm = i18n.t("items.vrm");
    const i18lookup = i18n.t("items.lookup");
    const i18stepOneLabel = i18n.t("items.stepOneLabel");
    const stepOneMessageP1 = i18n.t("items.stepOneMessageP1");
    const stepOneMessageP2 = i18n.t("items.stepOneMessageP2");
    const stepOneMessageP3 = i18n.t("items.stepOneMessageP3");
    const i18copyRightText = i18n.t("items.copyRightText");
    const i18brandSelectionPageLabel = i18n.t("items.brandSelectionPageLabel");
    const myDomain = navigationService.getCouncilDomain();
    const [lookupError, setLookupError] = useState('');
    const [isLoading, setIsLoading] = useState<any>(false);
    const logos: Record<string, any> = {
        hounslow: hounslowLogo,
        knowsley: knowsleyLogo,
        lambeth: lambethLogo,
        oldham: oldhamLogo,
        common: defaultLogo,
    };

    const logo = logos[myDomain] || logos.common;

    useEffect(() => {
        checkLookupOptions();
    }, []);

    return (

        <View style={styles.body}>
            {isLoading && <ActivityIndicator size="large" style={styles.loadingIndicator}></ActivityIndicator>}
            <View style={styles.rowItemTitle}>
                <TouchableOpacity onPress={() => {
                    navigation.navigate("Home")
                }}>
                    <Image style={styles.logo}
                           source={logo}
                           resizeMode="center"
                    />
                </TouchableOpacity>
                <h1 style={styles.form___h1}>{i18title}</h1>
            </View>
            <View style={styles.form}>
                <View>
                    <View style={{marginBottom: isLowDimension ? "1%" : "2%", marginTop: isLowDimension ? "1%" : "2%"}}>
                        <Text style={{fontSize: isLowDimension ? "3.2vw" : "1.7vw"}}>
                            We are currently upgrading our PCN Payment System.
                        </Text>
                        <Text style={{fontSize: isLowDimension ? "3.2vw" : "1.7vw"}}>
                            We are working to minimise any disruption to this service, please try again in a few hours.
                        </Text>
                        <Text style={{fontSize: isLowDimension ? "3.2vw" : "1.7vw"}}>
                             Thank you for your patience during this time.
                        </Text>
                    </View>
                </View>
            </View>
            <View style={styles.viewFooter}>
                <Text style={styles.footerText}>{i18copyRightText}</Text>
                {myDomain == 'ccp' &&
                    <View style={styles.viewFooterMenu}>
                        <TouchableOpacity onPress={() => {
                            navigation.navigate("DomainSelection")
                        }}>
                            <Text style={styles.footerText}>
                                {i18brandSelectionPageLabel}
                            </Text>
                        </TouchableOpacity>
                    </View>
                }
            </View>
        </View>
    );
};

export default KnowsleyHomeView;

